<template>
	<div class="booking-form__section">
		<div class="booking-form__section-wrapper">
			<oh-heading
				:caption="componentName"
				:anchor="componentKebab"
				:selection="headerSelect"
				:canVisible="canIIsVisible"
				@toggleVisibility="toggleVisibility"
			/>

			<transition-expand>
				<div class="booking-form__section-details booking-form__service flex-vertical" v-if="isVisible">
					<div class="b-line b__item b__item-service b-line-yellow flex-horizontal" v-for="(service, i) in services" :key="i">
						<label class="b__item-label flex-vertical" :class="{ 'b__item-label-highlight': service.name === 'Střih precizní klasika' }">
							<div class="service__label-main flex-horizontal">
								<input
									class="b__item-input"
									type="radio"
									:id="`service_${i}`"
									:name="service.type"
									v-model="selected"
									:value="service.id"
									@change="select(service)"
								/>
								<div class="service-header flex-horizontal">
									<span class="service-checkbox"></span>
									<span class="service-name booking-bold">{{ service.name }}</span>
									<span class="service-price booking-regular-nc">{{ $n(service.price, 'currency') }}</span>
								</div>
								<div class="flex-break"></div>
								<div class="service__label-description">
									<div class="service-details__tag-container">
										<div class="service-details__tags booking-small">
											<span class="service-details__tags-item" v-for="(tag, i) in service.tags" :key="i">{{ tag }}</span>
										</div>
										<div class="service-details__tags service-details__tags-secondary booking-small">
											<div class="service-details__tags-item service-details__tags-item-time-icon">
												<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
													<path
														fill-rule="evenodd"
														d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
														clip-rule="evenodd"
													/>
												</svg>
											</div>
											<span class="service-details__tags-item service-details__tags-item-time">{{ service.duration }}min</span>
										</div>
									</div>
									<span class="service-details booking-small">{{ service.description }}</span>
								</div>
							</div>
						</label>
					</div>
				</div>
			</transition-expand>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import bookingMixin from '../mixins/booking.mixin'
import OhHeading from './heading'

export default {
	name: 'Service',

	mixins: [bookingMixin],

	components: { OhHeading },

	data() {
		return {
			services: [],
			selected: null,
		}
	},

	computed: {
		headerSelect() {
			if (this.booking.service) return this.booking.service.name
			if (this.selected) return this._.find(this.services, { id: this.selected }).name
			return ''
		},
	},

	methods: {
		...mapActions({ set: 'booking/setService' }),
		async select(service) {
			await this.set(service.id)
			this.nextStep()
		},

		async getData() {
			let { data } = await this.$http.get(`/bs/${this.booking.id}/services`)
			this.services = data.data
			this.selected = this.booking.service?.id ?? null
		},
	},
}
</script>
